import Joi from 'joi';
const deviceVideoSchema = Joi.object({
  type: Joi.string().valid('asset').required(),
  data: Joi.string().required(),
  title: Joi.string().allow('', null).required(),
  description: Joi.string().allow('', null).required(),
  poster: Joi.string().allow('', null).required()
}).unknown(true);
const videoDataSchema = Joi.object({
  desktop: deviceVideoSchema.required(),
  tablet: deviceVideoSchema.required(),
  mobile: deviceVideoSchema.required()
}).unknown(true);
export default videoDataSchema;